import { Utility } from 'src/helpers/new';

export const API_ROUTES = {
    COURSES: {
        listAllChapters: (courseId?: string, queryParams?: any) =>
            `v1/courses/${courseId}/chapters${Utility.buildQueryString(queryParams)}`,
        listAllLessons: (courseId: string, chapterId: string, queryParams?: object) =>
            `v1/courses/${courseId}/chapters/${chapterId}/lessons${Utility.buildQueryString(queryParams)}`,
        updateLessonById: (source: string, lessonId: string) => `/${source}/lessons/${lessonId}/live`,
        getCourseLessonById: (lessonId: string) => `courses/lessons/${lessonId}`,
        reorderContent: (source: string) => `courses/${source}/reorder`,
        addChapter: () => `/courses/chapters`,
        updateChapter: (chapterId: string) => `/courses/chapters/${chapterId}`,
        deleteChapter: (chapterId: string) => `/courses/chapters/${chapterId}`,
        addLesson: () => `/courses/lessons`,
        deleteLesson: (lessonId: string) => `/courses/lessons/${lessonId}`,
    },
    CREATION_LIBRARY: {
        createPromptLibrary: () => `v1/prompt-library`,
        listAllPromptLibrary: (queryParams?: any) => `v1/prompt-library${Utility.buildQueryString(queryParams)}`,
        getPromptById: (promptId: string) => `v1/prompt-library/${promptId}`,
        deletePrompt: (promptId: string) => `v1/prompt-library/${promptId}`,
        createConversation: () => `creation-library/conversation`,
        validateAttachLessons: () => 'creation-library/conversation/validate-attach-lessons',
        sendConversationMessage: () => 'creation-library/conversation/message',
        editPrompt: (promptId: string) => `v1/prompt-library/${promptId}`,
        onCreateConversation: () => 'creation-library/conversation',
        onUpdateConversation: (conversationId: string) => `creation-library/conversation/${conversationId}`,
    },
    ANALYTICS: {
        getReportList: (queryParams: string) => `v1/analytics/reports/report-name?${queryParams}`,
        getUserAcquisitionReport: (queryParams?: string) => `v1/analytics/reports/user-acquisition?${queryParams}`,
        getUserAcquisitionChartReport: () => 'v1/analytics/reports/user-acquisition/chart',
    },
    CORE_CREATION: {
        listAllCoreChapter: (coreCourseId?: string, queryParams?: any) =>
            `v1/core/${coreCourseId}/chapters${Utility.buildQueryString(queryParams)}`,
        getCoreCourseLessonById: (coreCourseId: string, chapterId: string, queryParams?: object) =>
            `v1/core/${coreCourseId}/chapters/${chapterId}/lessons${Utility.buildQueryString(queryParams)}`,
    },
    ORDER_REPORTING: {
        downloadReport: (reportId: string) => `reporting/download-report/${reportId}`,
        deleteReport: (reportId: string) => `v1/orders/reports/${reportId}`,
    },
    EVENT_TRACKING: {
        metaTrackEvent: () => 'v1/tracking/meta-ads/track-event',
    },
    ADMIN_USER: {
        getAdminUser: (userId: string) => `/users/${userId}`,
    },
    BROADCAST: {
        getBroadcastUserCount: (mailingLists: string, categoryId: string) =>
            `broadcast/user-data/${mailingLists}/${categoryId}`,
        createBroadcast: () => `/broadcast/create`,
        updateBroadcast: (broadcastId: string) => `broadcast/update/${broadcastId}`,
    },
    ADMINSETTINGS: {
        getPresets: () => `settings/tax-presets`,
        getSelectedPresetDetails: (id: string) => `settings/tax-presets/${id}`,
        updateStateTaxCode: (id: string, queryParams?: any) =>
            `settings/tax-presets/${id}${Utility.buildQueryString(queryParams)}`,
        deletePreset: (id: string, queryParams?: any) =>
            `settings/tax-presets/${id}${Utility.buildQueryString(queryParams)}`,
        createTaxPresets: () => `settings/tax-presets`,
        getTermsOfService: () => `settings/terms_of_service`,
        getPrivacyPolicy: () => `settings/privacy_policy`,
    },
    PACKAGES: {
        updateStateTaxCode: (packageId: string) => `packages/${packageId}/tax-preset/tax-class`,
        applyPreset: (packageId: string) => `packages/${packageId}/tax-preset`,
    },

    CHECKOUT: {
        validateAddress: () => `checkout/cart/validate-address`,
    },
};
